<template>
    <div ref="root">
        <slot></slot>
    </div>
</template>

<script>
import {MDCSelect} from '@material/select';
import {ref,onMounted} from "vue";

export default {
    name: "mdc-select",
    setup() {
        const root = ref();

        onMounted(() => {
            const selects2 = [].map.call(document.querySelectorAll('.mdc-select'), function(el) {
                return new MDCSelect(el);
            });
        })

        return {
            root
        };
    }
}
</script>

<style scoped>

</style>
